module.exports = __webpack_public_path__ + "img/rosemount-708-wireless-acoustic-transmitter-acoustic-discrete.500f4bd3.png";